import type { OnDestroy } from '@angular/core';
import { Directive, inject } from '@angular/core';
import type { Uuid } from '@common/types';
import { NonNullableFormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';

import { ESelectedEntityType } from '@common/types/layout.type';
import { LayoutFacade } from '@web/store/layout/layout.facade';
import { ImageEditorService } from '@web/shared/modals/image-editor-modal/image-editor.service';
import { TranslateService } from '@ngx-translate/core';

@Directive()
export abstract class AbstractBaseSettingsComponent implements OnDestroy {
    protected readonly translate: TranslateService = inject(TranslateService);
    protected readonly fb: NonNullableFormBuilder = inject(NonNullableFormBuilder);
    protected readonly layoutFacade: LayoutFacade = inject(LayoutFacade);
    protected readonly imageEditorService: ImageEditorService = inject(ImageEditorService);

    protected unsubscribe$ = new Subject<void>();

    constructor() {
        this.initForm();
    }

    protected abstract initForm(): void;

    public setSelectedTheme(): void {
        this.layoutFacade.setSelectedEntity({ entityType: ESelectedEntityType.theme });
    }

    public setSelectedBlock(blockId: Uuid): void {
        this.layoutFacade.setSelectedEntity({ entityType: ESelectedEntityType.block, entityId: blockId });
    }

    public setSelectedZeroBlock(blockId: Uuid): void {
        this.layoutFacade.setSelectedEntity({ entityType: ESelectedEntityType.zeroBlock, entityId: blockId });
    }

    public setSelectedSpecificBlock(blockId: Uuid): void {
        this.layoutFacade.setSelectedEntity({ entityType: ESelectedEntityType.specificBlock, entityId: blockId });
    }

    public setSelectedSpecificSection(sectionId: Uuid): void {
        this.layoutFacade.setSelectedEntity({ entityType: ESelectedEntityType.specificSection, entityId: sectionId });
    }

    public setSelectedColumn(columnId: Uuid): void {
        this.layoutFacade.setSelectedEntity({ entityType: ESelectedEntityType.column, entityId: columnId });
    }

    public setSelectedGrid(gridId: Uuid): void {
        this.layoutFacade.setSelectedEntity({ entityType: ESelectedEntityType.grid, entityId: gridId });
    }

    public ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
